
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/leagues/[modeId]",
      function () {
        return require("private-next-pages/leagues/[modeId].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/leagues/[modeId]"])
      });
    }
  